import * as HealthRecommendationI from "./HealthRecommendation";

export const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  HealthRecommendation: {
    default: {
      START: HealthRecommendationI.Start,
      Action: HealthRecommendationI.Action,
    },
  },
};

export default SequencePattern;